export const BACKOFFICE_ORGANIZATIONS_MONITORING = {
  TITLE: 'Configuración de monitorización',
  DESCRIPTION:
    'Configura los dashboards de OpenSearch, el instalador y las credenciales de firma para esta organización. Solo visible para superadmins.',
  FIELDS: {
    EVENT_STATISTICS_URL: {
      LABEL: 'URL de estadísticas de eventos',
      PLACEHOLDER: 'https://…?auth_token={TOKEN}',
      HELPER: 'Debe contener el marcador literal {TOKEN}.',
    },
    SECURITY_EVENTS_URL: {
      LABEL: 'URL de eventos de seguridad',
      PLACEHOLDER: 'https://…?auth_token={TOKEN}',
      HELPER: 'Debe contener el marcador literal {TOKEN}.',
    },
    AGENT_DASHBOARD_URL: {
      LABEL: 'URL del dashboard del agente',
      PLACEHOLDER: 'https://…?auth_token={TOKEN}',
      HELPER: 'Debe contener el marcador literal {TOKEN}.',
    },
    USERNAME: {
      LABEL: 'Usuario de OpenSearch',
      PLACEHOLDER: 'acme-user01',
    },
    JWT_SECRET: {
      LABEL: 'Secreto JWT',
      PLACEHOLDER: 'Pega el JWT en claro proporcionado por el equipo de monitorización',
      HELPER_EMPTY: 'Obligatorio — todavía no hay un secreto almacenado.',
      HELPER_SET: 'Ya hay un secreto almacenado. Déjalo vacío para mantenerlo.',
    },
    AGENT_FILE: {
      LABEL: 'Instalador del agente (.zip)',
      HELPER_EMPTY: 'Obligatorio — todavía no hay un instalador almacenado.',
      HELPER_SET: ({ fileName }: { fileName: string }) =>
        `Archivo actual: ${fileName}. Elige un archivo nuevo para reemplazarlo o déjalo vacío para mantenerlo.`,
    },
    SIEM_INDEXER_URL: {
      LABEL: 'URL del indexador SIEM',
      PLACEHOLDER: 'https://host:9200',
    },
    SIEM_USERNAME: {
      LABEL: 'Usuario SIEM',
      PLACEHOLDER: 'siem-readonly',
    },
    SIEM_PASSWORD: {
      LABEL: 'Contraseña SIEM',
      PLACEHOLDER: 'Pega la contraseña del indexador',
      HELPER_EMPTY: 'Obligatorio — todavía no hay una contraseña almacenada.',
      HELPER_SET: 'Ya hay una contraseña almacenada. Déjala vacía para mantenerla.',
    },
    SIEM_SIDEBAR: {
      LABEL: 'Mostrar SIEM en la barra lateral',
    },
    API_URL: {
      LABEL: 'URL de la API de Wazuh',
      PLACEHOLDER: 'https://host:55000',
    },
    API_USERNAME: {
      LABEL: 'Usuario de la API de Wazuh',
      PLACEHOLDER: 'wazuh-api',
    },
    API_PASSWORD: {
      LABEL: 'Contraseña de la API de Wazuh',
      PLACEHOLDER: 'Pega la contraseña de la API',
      HELPER_EMPTY: 'Opcional. Necesaria para las acciones de endpoint (reiniciar, aislar).',
      HELPER_SET: 'Ya hay una contraseña almacenada. Déjala vacía para mantenerla.',
    },
  },
  SIEM_SECTION: {
    TITLE: 'Panel de seguridad (SIEM)',
    DESCRIPTION: 'Conexión al indexador Wazuh por organización usada por el panel SIEM.',
  },
  API_SECTION: {
    TITLE: 'API de Wazuh (acciones de endpoint)',
    DESCRIPTION: 'API del servidor Wazuh por organización usada para ejecutar respuestas activas en los endpoints.',
  },
  ERRORS: {
    URL_REQUIRED: 'La URL es obligatoria',
    URL_INVALID: 'Debe ser una URL válida que contenga el marcador {TOKEN}',
    USERNAME_REQUIRED: 'El usuario es obligatorio',
    JWT_REQUIRED: 'El secreto JWT es obligatorio en la primera configuración',
    AGENT_FILE_REQUIRED: 'Se requiere un archivo instalador del agente en la primera configuración',
    AGENT_FILE_TOO_LARGE: 'El instalador del agente debe ser de 800 MB o menos',
    AGENT_FILE_WRONG_EXTENSION: 'El instalador del agente debe ser un archivo .zip',
    AGENT_FILE_WRONG_MIME: 'El instalador del agente debe ser un archivo application/zip',
    SAVE_FAILED: 'Error al guardar la configuración de monitorización',
    UPLOAD_FAILED: 'Error al subir el instalador del agente',
    FORBIDDEN: 'No estás autorizado a realizar esta acción',
    SIEM_URL_INVALID: 'La URL del indexador SIEM debe ser una URL válida',
    SIEM_USERNAME_REQUIRED: 'El usuario SIEM es obligatorio',
    SIEM_PASSWORD_REQUIRED: 'La contraseña SIEM es obligatoria en la primera configuración',
  },
  SNACKBAR: {
    SAVED: 'Configuración de monitorización guardada',
  },
  SAVE: {
    LABEL: 'Guardar configuración de monitorización',
    SAVING: 'Guardando...',
  },
}
